import { render } from "./AdminPendingRequest.vue?vue&type=template&id=866f2bd4"
import script from "./AdminPendingRequest.vue?vue&type=script&lang=js"
export * from "./AdminPendingRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__